require("./atobbtoa/atobbtoa")
require("angular-route")
require("angular-sanitize")
require("angular-cookies")
require("angular-animate")
require("./ui-bootstrap/ui-bootstrap-tpls-2.5.0")
require("./colorpicker/bootstrap-colorpicker.js")
require("./colorpicker/bootstrap-colorpicker-module.js")
require("./json-formatter/json-formatter")
require("./ngToast/ngToast")
// @ts-ignore global object boooh
window.bowser = require('bowser')
